import { render } from "./MainFooter.vue?vue&type=template&id=6dc5b765&ts=true&lang=pug"
import script from "./MainFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainFooter.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__